import { Cache } from './main.js'

export class HttpCache extends Cache {
	constructor(settings={}) {
		super('http-cache', settings, 'uid', (req) => `${new Date().getTime()}_${req.path}`)
	}
}